import { dataTypes, Radio } from 'cat-ecommerce-alloy';
import styles from './styles.module.scss';
import SOSTableMobileView from './SOSTableMobileView';
import Field from '@app/components/common/form/Field';
import UnitPriceTableHeader from '../common/UnitPriceTableHeader';
import UnitPriceTableCell from '../common/UnitPriceTableCell';
import { getAvailability } from '../common/commonUtils';
import TooltipDisclaimer from '@app/components/common/Availability/TooltipDisclaimer';
import {
  getAvailabilityPickupText,
  getAvailabilityTitle
} from '@app/components/common/Availability/Common/util';

const displayOnDesktopOnly = 'd-none d-lg-table-cell';
const displayOnMobileOnly = 'd-lg-none';

export const getTableSchema = (
  t,
  currency,
  isLG,
  isQuantityMergeEnabled,
  isDeliveryEnabled,
  isPickUpEnabled
) => {
  const desktopSchema = [
    {
      id: 'sos',
      label: t('SOURCE_OF_SUPPLY'),
      className: displayOnDesktopOnly,
      padding: '0.125rem 0.5rem'
    },
    {
      id: 'item',
      label: t('ITEM'),
      className: displayOnDesktopOnly
    },
    {
      id: 'requestedQuantity',
      label: t('REQUESTED_QUANTITY'),
      dataType: dataTypes.NUMBER,
      className: `${displayOnDesktopOnly} text-center`
    },
    {
      id: 'availability',
      label: (
        <span>
          <span className="u-color--DarkGray u-fs--14 text-univers--bold ms-2">
            {t('SHOPCART_AVAILABILITY')}
            {!isQuantityMergeEnabled && <sup>&dagger;</sup>}
            <TooltipDisclaimer />
          </span>
        </span>
      ),
      className: `${displayOnDesktopOnly} ps-5`,
      padding: '0.4rem 0.5rem'
    },
    {
      id: 'unitPrice',
      label: <UnitPriceTableHeader currency={currency} />,
      dataType: dataTypes.NUMBER,
      className: displayOnDesktopOnly
    }
  ];
  const mobileSchema = [
    {
      id: 'mobileCell',
      className: displayOnMobileOnly,
      contentClassName: `${styles['row-overflow']} position-relative pb-0`,
      width: '90%'
    }
  ];
  return isLG ? desktopSchema : mobileSchema;
};

export const RADIO_BUTTON = 'RADIO_BUTTON';

export const getCustomRenderers = (
  currency,
  isStoreAvailabilityEnabled,
  hoseAvailabilityLabel,
  sourcingToggle
) => ({
  sos: item => (
    <Field
      type="radio"
      as={Radio}
      size="small"
      data-testid="desktop-radio-buttons"
      name={item.referenceId}
      id={`${item.referenceId}_${item.sosCode}`}
      label={item.sos}
      value={`${item.id}`}
    />
  ),
  availability: item =>
    getAvailability(
      item,
      isStoreAvailabilityEnabled,
      hoseAvailabilityLabel,
      sourcingToggle
    ),
  unitPrice: item => (
    <UnitPriceTableCell
      unitPrice={item?.unitPrice}
      coreCharges={item?.coreCharges}
      showCoreCharges={!!item?.coreCharges}
      currency={currency}
    />
  ),
  mobileCell: item => (
    <SOSTableMobileView
      item={item}
      currency={currency}
      sourcingToggle={sourcingToggle}
    />
  )
});

export const getItemsWithRadioValues = (items, formikValues) =>
  Object.fromEntries(
    Object.keys(items).map(key => [
      key,
      {
        ...items[key],
        selectedSOS: +formikValues[key]
      }
    ])
  );

export const getSelectedSOSItems = items => {
  const selectedSOSItems = Object.values(items).map(item => {
    const { selectedSOS, requestedQuantity, sosList } = item;
    const selectedSOSPart = sosList[selectedSOS];
    return {
      ...selectedSOSPart,
      partNumber: selectedSOSPart.sosPartNumber,
      requestedQuantity,
      referenceId: item.referenceId
    };
  });
  return selectedSOSItems;
};
